import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "../screens/Home";
import ContactUs from "../screens/ContactUs";
import Shop from "../screens/Shop";
import Vendor from "../screens/Vendor";
import Aboutus from "../screens/Aboutus";
import ProductDetails from "../screens/ProductDetails";
import Wishlist from "../screens/Wishlist";
import Account from "../screens/Account";
import Checkout from "../screens/Checkout";
import Register from "../screens/Auth/Register";
import Login from "../screens/Auth/Login";
import Cart from "../screens/Cart";
import Orders from "../screens/Orders";
import { useAuthStore } from "../store/useAuthStore";
import { useCartStore } from "../store/useCartStore";
import PlacedOrderAnimation from "../components/PlacedOrderAnimation";
import ResetPassword from "../screens/Auth/ResetPassword";
import OrderDetails from "../components/OrderDetails";

const AppRouter = () => {

  const { checkAuth, authUser } = useAuthStore()
  const { getCart } = useCartStore()
  const checkAuthFunction = async () => {
    await checkAuth()
    await getCart(1, 10, '', '')
  }
  useEffect(() => {
    checkAuthFunction()
  }, [])

  return (
    <>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/product-details/:id" element={<ProductDetails />} />
        <Route path="/vendor" element={<Vendor />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/account" element={authUser ? <Account /> : <Login />} />
        <Route path="/checkout" element={authUser ? <Checkout /> : <Login />} />
        <Route path="/resetpassword" element={authUser ? <ResetPassword /> : <Login />} />
        <Route path="/cart" element={authUser ? <Cart /> : <Login />} />
        <Route path="/orders" element={authUser ? <Orders /> : <Login />} />
        <Route path="/order-detail/:id" element={authUser ? <OrderDetails /> : <Login />} />
        <Route path="/signup" element={<Register />} />
        <Route path="/success" element={<PlacedOrderAnimation />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </>
  );
};

export default AppRouter;
